// app/javascript/compcalc/components/utls/SingleSelectionList.jsx

import React from 'react';
import { withStyles } from '@material-ui/core/styles';

import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';


const styles = theme => ({
});


// props.items = array of strings, props.selectedIndex, props.onIndexChanged()
class SingleSelectionList extends React.PureComponent {

  constructor(props) {
    super(props);
  }

  render() {
    // console.log("SingleSelectionList.render()");

    // let { classes } = this.props;

    return (
      <div>
        {
          this.props.items.map((item, index) => (
            <ListItem dense button key={`${index}`}
                      selected={this.props.selectedIndex === index}
                      onClick={() => this.props.onIndexChanged(index)}>
              <ListItemText primary={`${item}`} />
            </ListItem>
          ))
        }
      </div>
    );
  }
};

export default withStyles(styles)(SingleSelectionList);
